import axios from "axios";
import { parseCookies } from "../../utils/Cookies";

interface WidthDrawServiceData {
  amount: number;
  actor: string;
}

export class WithdrawService {
  async call(endpoint: string, data: WidthDrawServiceData) {
    const url = `${endpoint}?f=wallet&s=withdraw-snips`;

    const formData: FormData = new FormData();
    formData.append("amount", data.amount.toString());
    formData.append("actor", data.actor);
    try {
      const request = await axios({
        url: url,
        method: "POST",
        data: formData,
      });

      return request;
    } catch (e) {
      throw new Error("Withdraw request fail!");
    }
  }
}

interface UpdateWithdrawServiceData {
  actor: string;
}
export class UpdateWithdrawService {
  async call(endpoint, data: UpdateWithdrawServiceData) {
    const url = `${endpoint}?f=wallet&s=update-snips-amount`;

    const formData: FormData = new FormData();
    formData.append("actor", data.actor);

    try {
      const request = await axios({
        url: url,
        method: "POST",
        data: formData,
      });

      return request;
    } catch (e) {
      throw new Error("Withdraw request fail!");
    }
  }
}
